import { createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/acciones';

// ACTIONS
function createActions(state, action) {
  state.actions = action.payload.data ? action.payload.data:[];
  
}

function conexionActions(state, action) {
  state.connection= action.payload.connection;
}

function errorActions(state, action) {
  state.error= action.payload.error ? action.payload.error:false;
  state.message= action.payload.message ? action.payload.message:"";
}


/**
 * Conexión
 */
const actionsReducer = createSlice({
  name: 'actions',
  initialState: initState,
  reducers: {
    createActions,
    conexionActions,
    errorActions
  },
});

export const actionsActions = {
  ...actionsReducer.actions,
};

export default actionsReducer.reducer;
